(() => {
  /** Kiğılı ile aynı suggest parametreleri — main.js fe.search() bunu kullanır. */
  window.hpPredictiveSearchSuggestUrl = (sectionId, query) => {
    const base =
      window.routes?.predictive_search_url ||
      `${(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/')}search/suggest`;

    const url = new URL(base, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('section_id', sectionId || 'predictive-search');
    url.searchParams.set('resources[type]', 'product,collection,article,query,page');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[limit]', '7');
    url.searchParams.set(
      'resources[options][fields]',
      'title,product_type,vendor,variants.title,variants.sku,tag,variants.barcode',
    );
    return url.toString();
  };
})();
